import { render } from "./ModulProdukte.vue?vue&type=template&id=1e667424"
import script from "./ModulProdukte.vue?vue&type=script&lang=js"
export * from "./ModulProdukte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__